import React from 'react';
import { roleLabel } from '../services/rolesService';

const CHIP = 'rounded-full px-2 py-0.5 text-xs';

/**
 * Tags summarising what a user can do: platform grants first, then one tag per role in each
 * organization (`Org · Role`). An organization with no role is flagged, since it grants nothing.
 * Each role tag's tooltip lists the permissions it grants there.
 */
function UserAccessTags({ user, catalog, showStatus = false }) {
  const memberships = Array.isArray(user?.memberships) ? user.memberships : [];
  const orgsWithoutMembership = (user?.organizations || []).filter(
    (name) => !memberships.some((m) => m.organization_name === name)
  );
  return (
    <div className="flex flex-wrap gap-1">
      {showStatus ? (
        <span className={`${CHIP} ${user?.is_active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
          {user?.is_active ? 'Active' : 'Inactive'}
        </span>
      ) : null}
      {user?.is_admin ? (
        <span className={`${CHIP} bg-blue-100 text-blue-800`} title="Every permission in every organization">
          Platform Admin
        </span>
      ) : null}
      {memberships.flatMap((m) => {
        const roles = m.roles || [];
        if (roles.length === 0) {
          return [
            <span key={`${m.organization_id}-none`} className={`${CHIP} bg-red-50 text-red-700 ring-1 ring-inset ring-red-200`} title="No role assigned: sees nothing in this organization">
              {m.organization_name} · No role
            </span>,
          ];
        }
        return roles.map((r) => (
          <span
            key={`${m.organization_id}-${r}`}
            className={`${CHIP} bg-[#E8EEF5] text-[#18181B]`}
            title={(m.permissions || []).length ? `${m.organization_name} permissions: ${m.permissions.join(', ')}` : undefined}
          >
            {m.organization_name} · {roleLabel(catalog, r)}
          </span>
        ));
      })}
      {orgsWithoutMembership.map((name) => (
        <span key={`${name}-legacy`} className={`${CHIP} bg-[#E8EEF5] text-[#18181B]`}>
          {name}
        </span>
      ))}
    </div>
  );
}

export default UserAccessTags;
